import React from 'react';

export default function EmptyBoxIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path d="M19.9997 20.4878L6.66797 28.7561L19.9997 37.0732L33.3338 28.7561L19.9997 20.4878Z" fill="#706B69" />
      <path d="M33.3341 28.8046L20 20.4875V7.18994L33.3341 15.4582V28.8046Z" fill="#9D948E" />
      <path d="M20 37.0731L33.3341 28.7561V15.4585L20 23.7756V37.0731Z" fill="#9D948E" />
      <path d="M6.66797 28.8046L19.9997 20.4875V7.18994L6.66797 15.507V28.8046Z" fill="#C2BAB5" />
      <path d="M19.9997 37.0732L6.66797 28.7561V15.5073L19.9997 23.7756V37.0732Z" fill="#C2BAB5" />
      <path d="M0 11.2438L13.3341 2.92676L20 7.19017L6.66829 15.5072L0 11.2438Z" fill="#DBD6D1" />
      <path d="M20 23.7756L33.3341 15.4585L40 19.6731L26.6683 27.9902L20 23.7756Z" fill="#DBD6D1" />
      <path d="M20 7.19518L26.6683 3.06104L40 11.3293L33.3341 15.4586L20 7.19518Z" fill="#DBD6D1" />
      <path d="M0 19.6439L6.66829 15.5073L20 23.7756L13.3317 27.9073L0 19.6439Z" fill="#DBD6D1" />
    </svg>
  );
}
